import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import privacyStyle from "assets/jss/material-kit-pro-react/views/privacySections/privacyStyle.js";

const useStyles = makeStyles(privacyStyle);

export default function SectionRefund() {
  const classes = useStyles();
  return (
    <div className={classes.featuresSection}>
      <h1 className={classes.title}>Refund Policy</h1>
      <p>Effective Date: June 25, 2026</p>

      <h2 className={classes.title}>Lesson Packages</h2>
      <p>
        Lesson packages are purchased in advance and added to your account as
        lesson credits.
      </p>

      <h2 className={classes.title}>Completed Lessons</h2>
      <p>Lessons that have already been completed are non-refundable.</p>

      <h2 className={classes.title}>Unused Lesson Credits</h2>
      <p>
        Unused lesson packages may be eligible for a refund at the sole
        discretion of Utah Swim Academy.
      </p>
      <p>
        If a refund is approved, a $25 administrative fee and a $10 payment
        processing fee will be deducted from the refund amount.
      </p>

      <h2 className={classes.title}>Change of Mind</h2>
      <p>
        Purchasing a lesson package reserves instructor availability and
        scheduling resources. Refund requests based solely on a change of mind
        are generally not approved. Any exception is at the sole discretion of 
        Utah Swim Academy.
      </p>

      <h2 className={classes.title}>24-Hour Cancellation Policy</h2>
      <p>
        Lessons canceled more than 24 hours before the scheduled lesson will
        have the lesson credit returned to the parent's account.
      </p>
      <p>
        Lessons canceled within 24 hours of the scheduled lesson forfeit that
        lesson credit and are not eligible for a refund or replacement, except
        where required by law or approved by Utah Swim Academy.
      </p>

      <h2 className={classes.title}>Program Fit</h2>
      <p>
        Utah Swim Academy reserves the right to discontinue services if
        we determine that our program is not an appropriate fit for a child or
        if continuing instruction would compromise safety or the learning
        environment.
      </p>
      <p>
        If Utah Swim Academy discontinues services, management may, at
        its sole discretion, approve a refund for any unused lesson credits,
        less applicable fees.
      </p>

      <h2 className={classes.title}>Medical Circumstances</h2>
      <p>
        Requests for refunds due to medical circumstances will be reviewed on a
        case-by-case basis. Documentation may be requested.
      </p>

      <h2 className={classes.title}>Weather Closures</h2>
      <p>
        If Utah Swim Academy cancels lessons due to weather (including
        lightning) or other academy-initiated closures, affected lesson credits
        will be returned to the parent's account.
      </p>

      <h2 className={classes.title}>Refund Method</h2>
      <p>
        Approved refunds will only be issued to the original payment method used
        for the purchase. Refunds will not be issued to another person or
        payment source unless required by law.
      </p>

      <h2 className={classes.title}>Policy Changes</h2>
      <p>
        Utah Swim Academy reserves the right to update this policy at
        any time. The policy in effect at the time of purchase will apply to
        that purchase.
      </p>

      <h2 className={classes.title}>Questions</h2>
      <p>
        For refund questions, contact{" "}
        <a href="mailto:JoD.utahswimacademy@gmail.com">
          JoD.utahswimacademy@gmail.com
        </a>
        .
      </p>
    </div>
  );
}
